export enum LibraryRoutesConfig {
	LIBRARY_BASE_URL = 'library',
	SCORM_TINCAN_SEGMENT = 'scorm-tincan',
	QUESTION_POOLS_SEGMENT = 'question_pools'
}

export class LibraryRoutes {
	public static readonly LIBRARY = LibraryRoutesConfig.LIBRARY_BASE_URL;
	public static SCORM_TINCAN_HOME_ROUTE = `${LibraryRoutesConfig.LIBRARY_BASE_URL}/${LibraryRoutesConfig.SCORM_TINCAN_SEGMENT}`;
}
